'use client'
import { layoutMaxWidth } from '@/Theme/UtilityStyles'
import { styled } from '@mui/material'
import React from 'react'

interface Props {
  bgColor?: string
  children: React.ReactNode
}

interface StyledElementProps {
  bgColor: string
}

const StyledElement = styled('main')<StyledElementProps>(({ theme, bgColor }) => ({
  margin: '0 auto',
  padding: `${theme.spacing(6)} ${theme.spacing(0)}`,
  backgroundColor: bgColor,
  [theme.breakpoints.down('mdplus')]: {
    padding: 0
  },
  '.content': {
    ...layoutMaxWidth
  }
}))

const BodyFullWidthContainer: React.FC<Props> = ({ bgColor, children }) => {
  return (
    <StyledElement bgColor={bgColor ? bgColor : 'none'}>
      <div className="content">{children}</div>
    </StyledElement>
  )
}

export default BodyFullWidthContainer
